import countryData from "./country.json";
import stateData from "./state.json";

interface Country {
  id: number;
  name: string;
}

interface State {
  id: number;
  name: string;
  country_id: number;
  Districts: string[];
}
interface City {
  id: number;
  name: string;
  state_id: number;
}

class CountryStateDistrict {
  private countries: Country[];
  private states: State[];
  private cachedCities: City[] = [];

  constructor() {
    this.countries = countryData as Country[];
    this.states = stateData as State[];
    this.generateCitiesFromDistricts();
  }

  private generateCitiesFromDistricts(): void {
    this.cachedCities = [];
    let cityId = 1;

    this.states.forEach(state => {
      state.Districts.forEach(districtName => {
        this.cachedCities.push({
          id: cityId++,
          name: districtName,
          state_id: state.id
        });
      });
    });
  }

  getAllCountries(): Country[] {
    return this.countries;
  }

  getAllStates(): State[] {
    return this.states;
  }

  getStatesByCountryId(countryId: number): State[] {
    return this.states.filter((state) => state.country_id === countryId);
  }

  // Legacy method that returns districts as City objects
  getAllCities(): City[] {
    return this.cachedCities;
  }

  // Legacy method maintained for backward compatibility
  getCitiesByStateId(stateId: number): City[] {
    return this.cachedCities.filter((city) => city.state_id === stateId);
  }

  // Legacy method maintained for backward compatibility
  getCitiesByStateName(stateName: string): City[] {
    const state = this.states.find((state) => state.name === stateName);
    if (state) {
      return this.cachedCities.filter((city) => city.state_id === state.id);
    }
    return [];
  }

  // New methods for working directly with districts
  getAllDistricts(): string[] {
    return this.states.flatMap((state) => state.Districts);
  }

  getDistrictsByStateId(stateId: number): string[] {
    const state = this.states.find((state) => state.id === stateId);
    return state ? state.Districts : [];
  }

  getDistrictsByStateName(stateName: string): string[] {
    const state = this.states.find((state) => state.name === stateName);
    return state ? state.Districts : [];
  }

  getStateByDistrictName(districtName: string): State | undefined {
    return this.states.find((state) => 
      state.Districts.includes(districtName)
    );
  }
}

export default new CountryStateDistrict();